import React from "react";
import PropTypes from "prop-types";
import { Table } from "components";
import {
    stringComparator,
    dateComparator,
    numberComparator
} from "utilities/table";
import { Modal, Icon, Button, Card, Radio, Select, message } from "antd";
import { List, OrderedMap } from "immutable";
import {VISIBILITY_REMARKS} from "./constants/index";
import { LEDGER_TYPES } from "./constants/enums";
import CompanyService from "./services/company-los-services";

const Remarks = OrderedMap(VISIBILITY_REMARKS);
const RadioGroup = Radio.Group;
class VisibilityViewTemplate extends React.Component {
    state = {
        ledgerData: this.props.rows,
        isFilterApplied: false,
        modalVisible: false,
        expandedRowKeys: [],
        selectedViewType: 3,
        selectedRemark: "",
        selectedDate: "",
        currentPage: 1,
        selectedLedger: null,
        selectedLedgerId: null
    }
    pageSize = 20;
    // onApiXlsxDownload = () => {
    //     ReportsService.downloadReport(this.props.reportId).then(res => {
    //         var blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
    //         var elem = window.document.createElement("a");
    //         elem.href = window.URL.createObjectURL(blob);
    //         elem.download = `${this.props.reportName}.xlsx`;
    //         document.body.appendChild(elem);
    //         elem.click();
    //         document.body.removeChild(elem);
    //     });
    // }

    componentDidMount() {
        let filters = {
            page_size: this.pageSize,
            page: this.state.currentPage,
            remarks: this.state.selectedRemark
        };
        this.props.fetchVisibilityData(filters, {
            status: this.state.selectedViewType,
            date: this.state.selectedDate
        });
    }

    toggleModal = () => {
        this.setState({
            modalVisible: !this.state.modalVisible,
            modalData: this.state.modalVisible ? {} : this.state.modalData
        });
    }

    modalOpen = (_) => {
        this.setState({
            modalData: _.month_year_data,
            selectedLedger: _.ledger_name,
            selectedLedgerId: _.id
        }, () => {
            this.toggleModal();
        });
    }

    approve = () => {
        CompanyService.approveLedgerAnalysis(JSON.stringify([this.state.selectedLedgerId])).then((_) => {
            this.toggleModal();
            this.fetchData();
            message.success(_.data);
        }).catch(() => {
            message.error("Unable to approve");
        });
    }

    reject = () => {
        CompanyService.rejectLedgerAnalysis(JSON.stringify([this.state.selectedLedgerId])).then((_) => {
            this.toggleModal();
            this.fetchData();
            message.success(_.data);
        }).catch(() => {
            message.error("Unable to reject");
        });
    }

    onPageChange = (page, pageSize) => {
        this.pageSize = pageSize;
        this.setState({
            currentPage: page
        }, () => {
            let filters = {
                page_size: this.pageSize,
                page: this.state.currentPage,
                remarks: this.state.selectedRemark
            };
            this.props.fetchVisibilityData(filters, {
                status: this.state.selectedViewType,
                date: this.state.selectedDate
            });
        });
    }

    onPageSizeChange = (page, pageSize) => {
        this.pageSize = pageSize;
        this.setState({
            currentPage: page
        }, () => {
            let filters = {
                page_size: this.pageSize,
                page: this.state.currentPage,
                remarks: this.state.selectedRemark
            };
            this.props.fetchVisibilityData(filters, {
                status: this.state.selectedViewType,
                date: this.state.selectedDate
            });
        });
    }

    openCase = (id) => {
        CompanyService.getCaseId(id).then((_) => {
            if(_.data && _.data.case_id) {
                this.props.history.replace(`/app/inbox/${_.data.case_id}/case_details`);
            } else {
                message.error("Case does not Exist for this Ledger");
            }
        }).catch(() => {
            message.error("Failed to fetch Case Details for this Ledger");
        });
    }

    renderModal = () => {
        const { childColumns, loading } = this.props;
        if(!this.state.modalVisible) {
            return;
        }
        return ( <Modal 
            footer={null}
            width={900}
            closable={true}
            destroyOnClose={true}
            visible={this.state.modalVisible}
            onCancel={this.toggleModal}
        >
            <div className={"d-flex flex-row align-items-center justify-content-space-between p-5"}>
                <h2 style={{
                    margin: 0,
                    fontSize: "20px"
                }}>
                    {this.state.selectedLedger}
                </h2>
                {this.state.selectedViewType === 3 ? <div>
                    <Button type={"primary"} onClick={this.approve} className={"m-5"}>Approve</Button>
                    <Button type={"danger"} onClick={this.reject} className={"m-5"}>Reject</Button>
                </div> : null}
            </div>
            <div>
                <Table
                    title={""}
                    scrollX={true}
                    columns={childColumns}
                    data={new List([this.state.modalData])}
                    loading={loading}
                    showXlsxBtn={false}
                    noRowSelection={true}
                    showFilters={false}
                    size={"small"}
                    pagination={false}
                    tablePagination={false}
                    showTopSection={false}
                />
            </div>
        </Modal>);
    }

    customExpandIcon = (props) => {
        return (
            <a onClick={e => {
                e.preventDefault();
                this.modalOpen(props);
            }}>
                <Icon type={"info-circle"} style={{
                    fontSize: "16px"
                }} />
            </a>
        );
    }

    onChangeOption = (e) => {
        this.setState({
            selectedViewType: e.target.value
        }, () => {
            this.fetchData();
        });
    }

    bulkApprove = (ids) => {
        CompanyService.approveLedgerAnalysis(JSON.stringify(ids)).then((_) => {
            this.fetchData();
            message.success(_.data);
        }).catch(() => {
            message.error("Unable to approve");
        });
    }

    bulkReject = (ids) => {
        CompanyService.rejectLedgerAnalysis(JSON.stringify(ids)).then((_) => {
            this.fetchData();
            message.success(_.data);
        }).catch(() => {
            message.error("Unable to reject");
        });
    }

    fetchData = () => {
        let filters = {
            page_size: this.pageSize,
            page: this.state.currentPage,
            remarks: this.state.selectedRemark
        };
        this.props.fetchVisibilityData(filters, {
            status: this.state.selectedViewType,
            date: this.state.selectedDate
        });
    }



    render() {
        const { rows, columns, loading } = this.props;
        const columnsWithSorter = columns.map(_ => {
            let col = _;
            if(col.dataType === 1 || col.dataType === 2) {
                col.sorter = (a,b) => numberComparator(a.dataIndex, b.dataIndex);
            }

            if(col.dataType === 3) {
                col.sorter = (a,b) => stringComparator(a.dataIndex, b.dataIndex);
            }

            if(col.dataType === 4 || col.dataType === 5) {
                col.sorter = (a,b) => dateComparator(a.dataIndex, b.dataIndex);
            }

            if(col.dataType === 6) {
                col.sorter = (a,b) => numberComparator(a.dataIndex, b.dataIndex);
            }
            return col;
        });
        const data = this.props.rows || rows;
        const Ops = (
            <RadioGroup
                className={"inbox-table d-flex"}
                onChange={this.onChangeOption}
                value={this.state.selectedViewType}
            >
                {LEDGER_TYPES.map((_, k) => (
                    <Radio key={k} value={_}>
                        {k}
                    </Radio>
                )).toList().toArray()}       
            </RadioGroup>
        );
        return (
            <Card
                className={"padless-card p-10"}
            >
                <div className={"d-flex mb-10"}>
                    <Select
                        placeholder={"Select Remark"}
                        style={{
                            minWidth: "200px"
                        }}
                        className={"mr-5"}
                        value={this.state.selectedRemark}
                        onSelect={(val) => this.setState({
                            selectedRemark: val
                        }, () => this.fetchData())}
                    >
                        <Select.Option key={"remark"} value={""}>
                            {"Select Remark"}
                        </Select.Option>
                        {Remarks.map((_) => (
                            <Select.Option key={_} value={_}>
                                {_}
                            </Select.Option>
                        )).toList().toArray()}
                    </Select>
                    {this.state.selectedViewType === 1 && <Select
                        placeholder={"Select Date"}
                        style={{
                            minWidth: "200px"
                        }}
                        className={"mr-5"}
                        value={this.state.selectedDate}
                        onSelect={(val) => this.setState({
                            selectedDate: val
                        }, () => this.fetchData())}
                    >
                        <Select.Option key={"date"} value={""}>
                            {"Select Date"}
                        </Select.Option>
                        {this.props.dateFilters && this.props.dateFilters.map((_) => (
                            <Select.Option key={_.create_date} value={_.create_date}>
                                {_.create_date}
                            </Select.Option>
                        ))}
                    </Select>}
                </div>

                <Table
                    title={Ops}
                    columns={columnsWithSorter}
                    checkedColumns={columnsWithSorter.map(_ => _.dataIndex).toList().toArray()}
                    keyFilter={"id"}
                    data={data && data.map(_ => {
                        let row = _;
                        if(this.state.selectedViewType === 1) {
                            row.ledger_name = <a href={"#"} onClick={this.openCase.bind(null, _.id)}>{_.ledger_name}</a>;
                        }
                        row["expand"] = this.customExpandIcon(_);
                        return row;
                    })}
                    bulkAction={[
                        ids => this.bulkApprove(ids),
                        ids => this.bulkReject(ids)
                    ]}
                    loading={loading}
                    expandIconAsCell={false}
                    showColumnSelector={false}
                    bulkActionName={this.state.selectedViewType === 3 ? ["Approve", "Reject"] : []}
                    showBulkActionBtn={this.state.selectedViewType === 3 ? true : false}
                    showXlsxBtn={false}
                    noRowSelection={false}
                    showFooter={false}
                    showFilters={false}
                    fixedColsLeft={["ledger_name"]}
                    fixedColsRight={["expand"]}
                    size={"small"}
                    bulkActionSelectedKey={"id"}
                    showPaginationOnly={true}
                    pagination={{
                        current: this.state.currentPage,
                        showSizeChanger: true,
                        defaultPageSize: 20,
                        pageSizeOptions: [
                            "20",
                            "50",
                            "100",
                            "500"
                        ],
                        position: "bottom",
                        total: this.props.totalEntries,
                        onChange: (page, pageSize) =>
                            this.onPageChange(page, pageSize),
                        onShowSizeChange: this.onPageSizeChange
                    }}
                    showTopSection={true}
                    spanConfig={{
                        title: 4,
                        filters: 10
                    }}
                />
                {this.renderModal()}
            </Card>
        );
    }
}

VisibilityViewTemplate.propTypes = {
    rows: PropTypes.object,
    expandable: PropTypes.bool,
    columns: PropTypes.object,
    loading: PropTypes.bool,
    reportName: PropTypes.string,
    reportId: PropTypes.number,
    childColumns: PropTypes.object,
    fetchVisibilityData: PropTypes.func,
    totalEntries: PropTypes.number,
    companyId: PropTypes.string,
    dateFilters: PropTypes.array,
    history: PropTypes.object
};

export default VisibilityViewTemplate;
